import React from 'react';
import PropTypes from 'prop-types';
import s from '../PointsTable/PointsTable.scss';
import Link from '../../../../../components/Link/Link';
import { getPlayerLink } from '../CricketTeamList/utils';

const CricketRankingList = props => {
  const { className, isWapView, cricketRanking, totalRankings } = props;

  let ranks = cricketRanking?.['bat-rank']?.rank;
  if (ranks && Array.isArray(ranks)) {
    ranks = ranks.slice(0, totalRankings);
  }

  if (!cricketRanking?.['bat-rank']?.['rank-type'].includes('-team')) {
    let previousRank = null;
    return (
      <ul className={`${s.list} ${className} ${s.listActive}`}>
        <li className={s.head}>
          <span className={s.count}>#</span>
          <span className={`${s.countryname} ${s.players}`}>Player Name</span>
          <span className={s.countryname}>Country</span>
          <span className={s.matches}>Rating</span>
          {/* {!isWapView && activeTab && <span className={s.matches}>N/r</span>}
          <span className={s.matches}>net rr</span>
          <span className={s.matches}>points</span> */}
        </li>
        {ranks &&
          Array.isArray(ranks) &&
          ranks.map((rank, index) => {
            const currentRank =
              rank.no === '=' && previousRank !== null ? previousRank : rank.no;
            previousRank = rank.no !== '=' ? rank.no : previousRank;

            return (
              <li className={s.selected} key={index}>
                <span className={s.count}>{currentRank}</span>
                <span className={`${s.countryname} ${s.players}`}>
                  <Link
                    to={getPlayerLink(
                      false,
                      rank['Player-name'],
                      rank?.Player_id || rank?.id,
                      null,
                    )}
                  >
                    {rank['Player-name']}
                  </Link>
                </span>
                <span className={s.countryname}>
                  <span className={`${s.teamFlag} ${s[rank.Country]}`} />{' '}
                  {isWapView ? null : rank.team_name}
                </span>
                <span className={s.matches}>
                  <strong>{rank.Points}</strong>
                </span>
              </li>
            );
          })}
      </ul>
    );
  }

  return (
    <ul className={`${s.list} ${className} ${s.listActive}`}>
      <li className={s.head}>
        <span className={s.count}>#</span>
        <span className={s.countryname}>Country</span>
        <span className={s.matches}>Matches</span>
        {!isWapView && <span className={s.matches}>Points</span>}
        <span className={s.matches}>Rating</span>
        {/* {!isWapView && activeTab && <span className={s.matches}>N/r</span>}
          <span className={s.matches}>net rr</span>
          <span className={s.matches}>points</span> */}
      </li>
      {ranks &&
        Array.isArray(ranks) &&
        (() => {
          let previousRank = null; // Initialize variable to store the previous rank
          return ranks.map((rank, index) => {
            const currentRank =
              rank.no === '=' && previousRank !== null ? previousRank : rank.no;
            previousRank = rank.no !== '=' ? rank.no : previousRank;

            return (
              <li className={s.selected} key={index}>
                <span className={s.count}>{currentRank}</span>
                <span className={s.countryname}>
                  <span className={`${s.teamFlag} ${s[rank.shortname]}`} />{' '}
                  {isWapView ? rank.shortname : rank.Country}
                </span>
                <span className={s.matches}>{rank.Matches}</span>
                {!isWapView && (
                  <span className={s.matches}>
                    {parseInt(rank.Points, 10).toLocaleString()}
                  </span>
                )}
                <span className={s.matches}>
                  <strong>{rank.Rating}</strong>
                </span>
              </li>
            );
          });
        })()}
    </ul>
  );
};

CricketRankingList.propTypes = {
  cricketRanking: PropTypes.arrayOf({}),
  className: PropTypes.string,
  isWapView: PropTypes.bool,
  totalRankings: PropTypes.number,
};
CricketRankingList.defaultProps = {
  cricketRanking: null,
  className: '',
  isWapView: false,
  totalRankings: 10,
};

export default React.memo(CricketRankingList);
